export default "__VITE_ASSET__5fdecaf0__"